import React, {Component, Fragment} from 'react';
import {required, validateDisplay, isEmail} from "../../../hoc/Shared/utility";
import Button from "../../Button/Button";
import PropTypes from 'prop-types';

class StringInput extends Component {
    constructor (props) {
        super (props);

        this.state = {
            value: '',
            //Set the validation rules by set the init to false without start the validation first
            requiredRules: required(false, this.props.value, this.props.requiredMessage),
            isEmailRules: isEmail(false, this.props.value, this.props.isEmailMessage)
        };
    }

    // shouldComponentUpdate (nextProps, nextState, nextContext) {
    //     return nextProps.value !== this.props.value;
    // }


    static getDerivedStateFromProps (nextProps, prevState) {
        if (
            (nextProps.value !== prevState.value)

        ){
            let payload = {
                value: nextProps.value,
            };

            //Set to the payload when validation is true or not and set the init to true start validation
            if(nextProps.required){
                payload['requiredRules'] = required(true, nextProps.value, nextProps.requiredMessage);
            }

            if(nextProps.valid_email){
                payload['isEmailRules'] = isEmail(true, nextProps.value, nextProps.isEmailMessage);
            }

            return payload;
        }

        return null;
    }

    render() {

        const {id, name, onChange, className, defaultValue, disabled, required, placeholder, minLength, maxLength, onBlur, autoComplete, iconName, onSearchChange, readOnly, onSearchPress, valid_email, type} = this.props;

        const {value, requiredRules, isEmailRules} = this.state;

        //Export the validation classes and message
        const [ requiredClass, requiredMsg ] = validateDisplay(requiredRules);

        const [ isEmailClass, isEmailMsg ] = validateDisplay(isEmailRules);

        let inputType = !!(type) ? type : "text";

        if(isEmailClass === "is-invalid"){
            inputType = "email";
        }

        return (
            <Fragment>
                <input
                    type={inputType}
                    id={id}
                    value={value}
                    className={`form-control ${requiredClass} ${isEmailClass} ${className}`}
                    name={name}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    disabled={disabled}
                    required={required}
                    placeholder={placeholder}
                    minLength={minLength}
                    maxLength={maxLength}
                    onBlur={onBlur}
                    autoComplete={autoComplete}
                    readOnly={readOnly}
                    onKeyPress={onSearchPress}
                    valid_email={valid_email}
                />

                {iconName &&
                    <div className="searchIcon">
                        <Button
                            typeButton="button"
                            classValue="btn btn-sm"
                            buttonName={iconName}
                            clicked={onSearchChange}
                        />
                    </div>
                }

                {/*Display the message*/}
                <div className="invalid-feedback">
                    {requiredClass !== 'is-valid' && requiredMsg}
                    {(requiredClass === "is-valid" && isEmailClass === "is-invalid") && isEmailMsg}
                </div>
            </Fragment>
        )
    }
}

export default StringInput;

StringInput.propTypes = {
    id:         PropTypes.string.isRequired,
    name:       PropTypes.string.isRequired,
    onChange:   PropTypes.func.isRequired,
    onSearchChange: PropTypes.func,
    defaultValue:   PropTypes.string,
    value:          PropTypes.string,
    className:      PropTypes.string,
    disabled:       PropTypes.bool,
    required:       PropTypes.bool,
    placeholder:    PropTypes.string,
    minLength:      PropTypes.number,
    maxLength:      PropTypes.number,
    onBlur:         PropTypes.func,
    valid_email:    PropTypes.string,
    isEmailMessage:  PropTypes.string,
    requiredMessage: PropTypes.string,
    minLengthMessage: PropTypes.string,
    autoComplete:   PropTypes.string,
    iconName: PropTypes.any,
    onSearchPress: PropTypes.func
};

StringInput.defaultProps = {
    className: ''
};